export const modelsCompFn = ({ models, neededModels, isEmpty = false }) => {
  if (models === undefined) {
    return false;
  }
  if (models === null) {
    return isEmpty === true;
  }
  if (!Array.isArray(models)) {
    models = [models];
  }

  if (isEmpty) {
    return models.length === 0;
  }
  const neededIds = neededModels.map((o) => o.uid);
  const ids = models.map((o) => o.uid);
  return neededIds.some((el) => ids.indexOf(el) > -1);
};
